export default __webpack_public_path__ + "static/media/albanil.7199ca41.png";